import { render, staticRenderFns } from "./allVideo.vue?vue&type=template&id=74552f1e"
import script from "./allVideo.vue?vue&type=script&lang=js"
export * from "./allVideo.vue?vue&type=script&lang=js"
import style0 from "./allVideo.vue?vue&type=style&index=0&id=74552f1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports